import { useId } from "react";

export function Transfer2Icon({ className }: { className?: string }) {
  const id = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
      className={className}
    >
      <path
        fill={`url(#${id})`}
        d="M14 0C6.272 0 0 6.272 0 14s6.272 14 14 14 14-6.272 14-14S21.728 0 14 0m1.867 20.533v-2.8h-8.4v-2.8h13.066c-1.558 1.867-3.108 3.734-4.666 5.6m4.666-7.466H7.467c1.558-1.867 3.108-3.734 4.666-5.6v2.8h8.4z"
      />
      <defs>
        <linearGradient id={id} x1="0" x2="28" y1="14" y2="14" gradientUnits="userSpaceOnUse">
          <stop stopColor="#21a038" />
          <stop offset="1" stopColor="#186d27" />
        </linearGradient>
      </defs>
    </svg>
  );
}
